import { useLayoutEffect, useRef } from "react";
import { Input } from "@/components/ui/input";

// «500.000», «500 000» ou «500000» → «500000»; vírgula = cêntimos (só com decimals).
export const parseEuro = (s, decimals = false) => {
  let t = String(s ?? "").replace(/[\s\u00a0\u202f.]/g, "");
  if (!decimals) return t.replace(/\D/g, "");
  t = t.replace(/[^\d,]/g, "");
  const [int, ...rest] = t.split(",");
  return rest.length ? `${int}.${rest.join("").slice(0, 2)}` : int;
};

export const fmtEuroInput = (raw) => {
  if (raw == null || raw === "") return "";
  const [int, dec] = String(raw).split(".");
  const g = int.replace(/^0+(?=\d)/, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return dec != null ? `${g},${dec}` : g;
};

const sig = (s) => (s.match(/[\d,]/g) || []).length;
const posFor = (shown, n) => {
  let seen = 0;
  for (let i = 0; i < shown.length; i += 1) {
    if (seen === n) return i;
    if (/[\d,]/.test(shown[i])) seen += 1;
  }
  return shown.length;
};

export function EuroInput({ value, onChange, decimals = false, ...props }) {
  const ref = useRef(null);
  const caret = useRef(null);
  const shown = fmtEuroInput(value);
  useLayoutEffect(() => {
    if (caret.current != null && ref.current && document.activeElement === ref.current) {
      const p = posFor(shown, caret.current);
      ref.current.setSelectionRange(p, p);
    }
    caret.current = null;
  });
  const change = (e) => {
    const el = e.target;
    caret.current = sig(el.value.slice(0, el.selectionStart ?? el.value.length).replace(/\./g, ""));
    onChange(parseEuro(el.value, decimals));
  };
  return <Input ref={ref} type="text" inputMode={decimals ? "decimal" : "numeric"} autoComplete="off" value={shown} onChange={change} {...props} />;
}
